/*eslint-disable*/
export const I18NS = new Proxy({
  i18ns: {} as Record<string, string>,
  /** 请输入有效的邮箱地址! */
  ENTER_VALID_EMAIL_word: 'livecloud.product.login.enterValidEmail.word',
  /** 请输入有效的手机号! */
  ENTER_VALID_PHONE_WORD: 'livecloud.product.login.enterValidPhone.word',
  /** 两次输入的密码不一致! */
  PASSWORD_NOT_SAME_WORD: 'livecloud.product.login.passwordNotSame.word',
  /** {0}秒后重新获取验证码 */
  COUNTDOWN_WORD: 'livecloud.product.login.countdown.word',
  /** 统一身份认证 */
  UNI_AUTH_WORD: 'livecloud.product.login.uniAuth.word',
  /** 验证码不能为空 */
  NEED_CHECK_CODE_WORD: 'livecloud.product.login.needCheckCode.word',
  /** 手机登录 */
  PHONE_LOGIN_WORD: 'livecloud.product.login.phoneLogin.word',
  /** 获取验证码  */
  GET_CHECK_CODE_WORD: 'livecloud.product.login.getCheckCode.word',
  /** 邮箱验证码不能为空 */
  NEED_EMAIL_CHECK_CODE_WORD: 'livecloud.product.login.needEmailCheckCode.word',
  /** 请输入手机号  */
  ENTER_PHONE_NUM_WORD: 'livecloud.product.login.enterPhoneNum.word',
  /** 请输入密码  */
  ENTER_PASSWORD_WORD: 'livecloud.product.login.enterPassword.word',
  /** 下一步 */
  NEXT_STEP_WORD: 'livecloud.product.login.nextStep.word',
  /** 忘记密码  */
  FORGET_PASSWORD_WORD: 'livecloud.product.login.forgetPassword.word',
  /** 请输入短信验证码  */
  ENTER_CHECK_CODE_WORD: 'livecloud.product.login.enterCheckCode.word',
  /** 返回登录  */
  RETURN_WORD: 'livecloud.product.login.return.word',
  /** 密码不能为空 */
  NEED_PASSWORD_WORD: 'livecloud.product.login.needPassword.word',
  /** 账号登录  */
  ACCOUNT_LOGIN_WORD: 'livecloud.product.login.accountLogin.word',
  /** 手机号不能为空 */
  NEED_PHONE_WORD: 'livecloud.product.login.needPhone.word',
  /** 短信验证码不能为空 */
  NEED_SMS_CHECK_CODE_WORD: 'livecloud.product.login.needSmsCheckCode.word',
  /** 请再次输入密码  */
  ENTER_PASSWORD_AGAIN_WORD: 'livecloud.product.login.enterPasswordAgain.word',
  /** 确认密码不能为空 */
  NEED_EDIT_CONFIRM_PASSWORD_WORD: 'livecloud.product.login.needEditConfirmPassword.word',
  /** 请输入账号  */
  ENTER_ID_WORD: 'livecloud.product.login.enterId.word',
  /** 邮箱登录 */
  EMAIL_LOGIN_WORD: 'livecloud.product.login.emailLogin.word',
  /** 请输入邮箱  */
  ENTER_EMAIL_WORD: 'livecloud.product.login.enterEmail.word',
  /** 用户忘记密码而无法找回的，可携带本人身份证或学生证到信息中心登记后，由管理员予以修改，已完成手机号或者邮箱绑定的，可通过短信或邮件找回密码。  */
  WARNING_WORD: 'livecloud.product.login.warning.word',
  /** 完成 */
  FINISH_WORD: 'livecloud.product.login.finish.word',
  /** 请输入邮箱验证码  */
  ENTER_EMAIL_CHECK_CODE_WORD: 'livecloud.product.login.enterEmailCheckCode.word',
  /** 账号不能为空 */
  NEED_ACCOUNT_WORD: 'livecloud.product.login.needAccount.word',
  /** 邮箱不能为空 */
  NEED_EMAIL_WORD: 'livecloud.product.login.needEmail.word',
  /** 短信登录  */
  SMS_LOGIN_WORD: 'livecloud.product.login.smsLogin.word',
  /** 密码不能为空 */
  NEED_EDIT_PASSWORD_WORD: 'livecloud.product.login.needEditPassword.word',
  /** 企业微信或智慧福医APP扫码登录  */
  SCAN_QR_CODE_WORD: 'livecloud.product.login.scanQrCode.word',
  /** 请输入验证码  */
  ENTER_VERIFY_CODE_WORD: 'livecloud.product.login.enterVerifyCode.word',
  /** 登录  */
  LOGIN_BTN_WORD: 'livecloud.product.login.loginBtn.word',
  /** 账号规则: 学生登录账号为学号，教职工登录账号为工号 咨询电话: 0591-2288888 业务邮箱: ykdx@163.com Copyright @ 2018 福建医科大学 版权所有 闽ICP备12011212号  */
  BOTTOM_INFO_WORD: 'livecloud.product.login.bottomInfo.word',
  /**二维码刷新提示 */
  QR_CODE_REFRESH_WORD: 'livecloud.product.login.please.refresh',
  /** 请输入邮箱或者手机号  */
  ENTER_EMAIL_OR_PHONE_WORD: 'livecloud.product.login.enterEmailOrPhone.word',
  /** 请输入正确的邮箱或者手机号  */
  ENTER_VALID_EMAIL_OR_PHONE_WORD: 'livecloud.product.login.enterValidEmailOrPhone.word',
  /** 请输入邮箱或者手机号的验证码  */
  ENTER_EMAIL_OR_PHONE_CHECK_CODE_WORD: 'livecloud.product.login.enterEmailOrPhoneCheckCode.word',
  /**企业微信登录 */
  WORK_WX_LOGIN_WORD: 'livecloud.product.login.workwx.button.title',
  /** app下载 */
  APP_DOWNLOAD: 'livecloud.product.login.app.download.text',
  /** iphone版 */
  IOS_TEXT: 'livecloud.product.login.app.download.ios.text',
  /** android版 */
  ANDROID_TEXT: 'livecloud.product.login.app.download.android.text',
  /** 系统维护 */
  SYSTEM_CONSTRUCTION: 'livecloud.product.system.construction.word',
  /** 定期修改密码 */
  PERIODICALUPDATEPASSWORD_WORD: 'livecloud.product.login.periodicalUpdatePassword.word',
  /** 请输入旧密码 */
  ENTEROLDPASSWORD_WORD: 'livecloud.product.login.enterOldPassword.word',
  /** 修改成功，请重新登陆 */
  RELOGIN_WORD: 'livecloud.product.login.updatePassword.reLogin.word',
  /** 天内免登录 */
  BINTANG_WORD: 'livecloud.product.login.bintang.word',
  /** 微信登录*/
  WX_LOGIN: 'livecloud.product.login.wechat.button.title',
  /** 绑定登录 */
  BIND_LOGIN: 'livecloud.product.login.binding.title',
  /**微信绑定登录 */
  BIND_WX_TITLE: 'livecloud.product.login.wechat.binding.login.title',
  /**您登录的微信账号登录 */
  WX_ACCOUNT_DESC: 'livecloud.product.login.wechat.account.desc',
  /**微信扫码登录首次登录必须进行绑定登录，请进行绑定登录验证 */
  WX_ACCOUNT_TIP: 'livecloud.product.login.wechat.account.tip',
   /** 本页面将在{0}秒后过期 */
   TIME_DESC:                      'livecloud.product.login.page.expired.time.description',
   /** 立即刷新 */
   NOW_DESC:                       'livecloud.product.login.refresh.now.description'
}, {
  get: (target, key) => key === 'i18ns' ? target.i18ns : target.i18ns[target[key]]
})